import { CTitMoral } from '../../../../types';
export var list = [
    CTitMoral.GERANT,
    CTitMoral.ADMINISTRATEUR,
    CTitMoral.ADMINISTRATEUR_DELEGUE,
    CTitMoral.AUTRE,
];
